import { isElementInViewport } from "./isElementInViewport";
/**
 * Also checks parent scrolling
 * @param element
 * @returns
 */
export function isElementFullyInViewport(element) {
    // Get the element’s bounding rectangle
    const elementRect = element.getBoundingClientRect();
    // Check if the element is within the viewport
    const isInViewport = isElementInViewport(element);
    if (!isInViewport)
        return false;
    // Check each scrollable ancestor container
    let parent = element.parentNode;
    while (parent !== document.body &&
        parent !== document.documentElement &&
        parent != null &&
        parent instanceof HTMLElement) {
        const parentRect = parent.getBoundingClientRect();
        // Check if element is within each parent container’s bounds
        if (elementRect.top < parentRect.top ||
            elementRect.left < parentRect.left ||
            elementRect.bottom > parentRect.bottom ||
            elementRect.right > parentRect.right) {
            return false; // Element is outside of a container’s view
        }
        parent = parent.parentNode;
    }
    return true; // Element is fully in view of all containers
}
//# sourceMappingURL=isElementFullyInViewport.js.map